export default {
    good:      { weight: 2, color: '#0F0' },
    bad:       { weight: 2, color: '#F00' },
    empty:     { weight: 2, color: '#0033FF' },
    annot:     { weight: 0.1, color: '#77F', fillOpacity: 0.1 },
    doodle:    { weight: 2, color: '#000', opacity: 1 },
    search:    { weight: 0.1, color: '#FF0', fillOpacity: 0.4 },
    formEmpty: { weight: 2, color: '#DDE4FF' },
    formSaved: { weight: 2, color: '#DDE4FF' }
};
